import css from 'styled-jsx/css';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .UserMarksTable {
    :global(.ReactDataTable__wrapper) {
      overflow: auto;

      :global(.ReactDataTable) {
        :global(tr) {
          margin: 0;
          grid-template-columns: repeat(9, minmax(100px, 1fr)) minmax(100px, 2fr);
        }
        :global(.ReactDataTable__tbody-cell) {
          :global(.time) {
            display: block;
            color: #777777;
            font-weight: 300;
          }
        }
        :global(.ReactDataTable__tbody-row) {
          box-shadow: none;
        }
      }
    }

    :global(.UserMarksTable__utm) {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
`;

export { staticStyles };
